/////////////////////////////////////////////////////////////////////////////////////////////////////////
//  화일명 : clipboardUtils.ts
//  설명 : 클립보드 붙여넣기(Ctrl+V) 관련 공통 유틸 - 상담톡 입력창/상담요청 폼에서 화면캡처 등 클립보드의 이미지를
//        첨부파일로 붙여넣을 때 사용.
//        paste 이벤트(clipboardData)로 읽으므로 HTTP/HTTPS 모두에서 동작함(navigator.clipboard.read()는
//        HTTPS/localhost 전용이라 쓰지 않음).
/////////////////////////////////////////////////////////////////////////////////////////////////////////

const EXT_BY_TYPE: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/bmp': 'bmp',
};

const pad2 = (n: number) => String(n).padStart(2, '0');

/**
 * 붙여넣기 이벤트에서 클립보드의 이미지 파일을 꺼냄.
 *  - 텍스트가 함께 들어있으면(엑셀/워드 등에서 복사) 이미지로 붙이지 않고 빈 배열을 돌려줌 -> 호출측은 기본 붙여넣기(텍스트)를
 *    그대로 두면 됨. 텍스트 없이 이미지만 있을 때(화면캡처, 이미지 복사)만 파일로 돌려줌.
 *  - 화면캡처처럼 이름이 없는(image.png) 이미지는 "붙여넣기_YYYYMMDD_HHmmss.png"로 이름을 붙임(확장자가 있어야 말풍선에서
 *    이미지 미리보기가 됨). 탐색기에서 복사한 이미지 파일처럼 이름이 있으면 그 이름을 그대로 씀.
 * @returns 붙여넣은 이미지 File 배열(없으면 빈 배열)
 */
export const getPastedImageFiles = (e: { clipboardData: DataTransfer | null }): File[] => {
  const cd = e.clipboardData;
  if (!cd) return [];
  if ((cd.getData('text/plain') || '').length > 0) return [];

  const now = new Date();
  const stamp = `${now.getFullYear()}${pad2(now.getMonth() + 1)}${pad2(now.getDate())}_${pad2(now.getHours())}${pad2(now.getMinutes())}${pad2(now.getSeconds())}`;
  const result: File[] = [];
  Array.from(cd.items || []).forEach(item => {
    if (item.kind !== 'file' || !item.type.startsWith('image/')) return;
    const f = item.getAsFile();
    if (!f) return;
    const generic = !f.name || /^image\.\w+$/i.test(f.name);
    if (!generic) { result.push(f); return; }
    const ext = EXT_BY_TYPE[f.type] || 'png';
    const name = `붙여넣기_${stamp}${result.length > 0 ? `_${result.length + 1}` : ''}.${ext}`;
    result.push(new File([f], name, { type: f.type || 'image/png', lastModified: Date.now() }));
  });
  return result;
};
